import { SpecialtyReqsIds } from "constants/loadConstants/loadConstants";
import { specialtyRequirementsText, specialtyCantHave, specialtyTypesText, allSpecialtyText } from "constants/loadConstants/loadTextConstants";
import React from "react";

export const interleaveCommas = (arr: []) => {
  return arr.reduce((result, element, index, array) => {
    result.push(element);
    if(index === array.length - 2) {
      result.push(", and ")
    }else if (index < array.length - 1) {
      result.push(", ");
    }
    return result;
  }, []);
};

export const getLoadRequirementsText = (specialServicesData: any) => {
  if(!specialServicesData?.LoadEquipmentSpecialServices){
    return;
  }
  const allReqs = [...specialServicesData?.LoadEquipmentSpecialServices, ...specialServicesData?.LoadStopSpecialServices]
  let loadRequirementsText: any = []
  allReqs.forEach((req: any) => {
    if(specialtyRequirementsText[req.LoadSpecialServiceId]){
      loadRequirementsText.push(specialtyRequirementsText[req.LoadSpecialServiceId])
    }
  })
  if(allReqs.find((req: any) => req.LoadSpecialServiceId === SpecialtyReqsIds.NO_ROLL_DOORS)){
    loadRequirementsText.push(specialtyCantHave[SpecialtyReqsIds.NO_ROLL_DOORS])
  }
  loadRequirementsText = interleaveCommas(loadRequirementsText)
  if(loadRequirementsText.length && (loadRequirementsText[0] !== specialtyCantHave[SpecialtyReqsIds.NO_ROLL_DOORS])){
    loadRequirementsText.unshift("requires ")
  }
  return loadRequirementsText
}

export const getLoadTypeText = (specialServicesData: any) => {
  if(!specialServicesData?.LoadEquipmentSpecialServices){
    return;
  }
  const allReqs = [...specialServicesData?.LoadEquipmentSpecialServices, ...specialServicesData?.LoadStopSpecialServices]
  let loadTypeText: any = []
  allReqs.forEach((req: any) => {
    if(specialtyTypesText[req.LoadSpecialServiceId]){
      loadTypeText.push(specialtyTypesText[req.LoadSpecialServiceId])
    }
  })
  if(specialServicesData?.HasHazmatCommodities){
    loadTypeText.push(<b>hazmat</b>)
  }
  loadTypeText = interleaveCommas(loadTypeText)
  if(loadTypeText.length){
    loadTypeText.unshift("is a ")
  }
  return loadTypeText
}

export const getHasSpecialtyText = (LoadEquipmentSpecialServices: [{ LoadSpecialServiceId: number }], LoadStopSpecialServices: [{ LoadSpecialServiceId: number }], HasHazmatCommodities: boolean ) => {
  if(HasHazmatCommodities){
    return true;
  }
  if(LoadEquipmentSpecialServices && LoadStopSpecialServices){
    const allReqs = [...LoadEquipmentSpecialServices, ...LoadStopSpecialServices]
    return !!allReqs.find((req) => !!allSpecialtyText[req.LoadSpecialServiceId])
  }
}
